import Axios from "axios";
import Environment from "@/services/Environment";

export default class Cross {
    static UNREAD_MESSAGES_ENDPOINT_DEV          = 'https://dev.apiv1.anandasociety.com/messages/check.php'
    static UNREAD_MESSAGES_ENDPOINT_PROD         = 'https://apiv1.anandasociety.com/messages/check.php'

    static async unread(token){
        try{
            const form = new FormData()
            form.append('token', token)
            let response = await Axios.post((Environment.getEnvironment() === 'dev'? Cross.UNREAD_MESSAGES_ENDPOINT_DEV : Cross.UNREAD_MESSAGES_ENDPOINT_PROD), form)
            return response.data

        } catch(error) {
            return {"success": false, 'message': error};
        }
    }
}